import {ISystem, ISystemRole, ITableColumn} from "../../../../index";

interface IRole extends ISystemRole {
    $system: ISystem
}

type TRoleKey = keyof IRole

interface IRoleColumn extends ITableColumn<IRole> {
    key: TRoleKey
}
